export default {
  loading: true,
  account: {},
  notifications: []
}
